import { Button } from 'component/Button'
import { SearchInput } from 'component/Input/SearchInput'
import { Scroll } from 'component/Scroll'
import { Divider, Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { CategoryCheckbox } from 'page/StartScreen/combine/category/CategoryCheckbox'
import { getCategoryGroupTranslation, getCategoryTranslations } from 'page/StartScreen/combine/utils'
import { Fragment } from 'react'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { Category } from 'type/rec'
import { map } from 'util/iterable'

export const CategoryStep = observer(() => {
  const item = store.item!
  const { category, categories_filtered } = item.rec
  let group_current = ''

  const onSearch = useLatestCallback((value: string) => {
    category.search = value
  })

  const onRemove = useLatestCallback((value: Category) => {
    category.toggle(value)
  })

  const onReset = useLatestCallback(() => {
    category.clear()
  })

  return <Vertical gap={24} tall>
    {!opt.stand && <SearchInput large value={category.search}
      onChange={onSearch} placeholder={i18n('SearchByCategory')} />}

    <Vertical oh margin={[0, -12]}>
      <Scroll>
        <Vertical gap={24} pad={[0, 12]}>
          {!!category.selection.size && <Space gap={8} wrap>
            {map(category.selection, category => <Fragment key={category.ids[0]}>
              <Button gap={4} primary onClick={() => onRemove(category)}>
                <Typo size={13} upper>
                  {getCategoryTranslations(category.name)}
                </Typo>
                <Icon size={16} name="close" />
              </Button>
            </Fragment>)}
            <Button link onClick={() => onReset()}>
              {i18n('Reset')}
            </Button>
          </Space>}

          <Vertical>
            {!categories_filtered.length && <Space height={200} center>
              <Typo size={13} upper secondary>
                {i18n('NothingFound')}
              </Typo>
            </Space>}
            {categories_filtered.map((category, i) => {
              let group = category.group
              const changed = group !== group_current
              group_current = group
              const title = changed && !!group

              return <Fragment key={category.ids[0]}>
                {i > 0 && <Divider tertiary />}
                {title && i > 0 && <Space height={24} />}
                {title && <Space minHeight={24}>
                  <Typo size={15} accent upper primary>
                    {getCategoryGroupTranslation(group)}
                  </Typo>
                </Space>}
                <CategoryCheckbox category={category} />
              </Fragment>
            })}
          </Vertical>
        </Vertical>
      </Scroll>
    </Vertical>
  </Vertical>
})
